import { render, staticRenderFns } from "./CompensationReviewApproval.vue?vue&type=template&id=9fd63856"
import script from "./CompensationReviewApproval.vue?vue&type=script&lang=js"
export * from "./CompensationReviewApproval.vue?vue&type=script&lang=js"
import style0 from "./CompensationReviewApproval.vue?vue&type=style&index=0&id=9fd63856&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports